import { useXeroClient } from "../../../../hooks";
import { useQuery } from "react-query";
import produce from "immer";

export const useTrackingCategories = (enabled = true) => {
  const client = useXeroClient();

  return useQuery(
    [
      "trackingcategories",
      {
        params: {
          Status: "ACTIVE",
        },
      },
    ],
    ({ queryKey }) => client.get(...queryKey).get("data"),
    {
      enabled,
      placeholderData: [],
      select: (v) =>
        produce(v, (draft) => {
          for (const i of draft) {
            const { Options, TrackingCategoryID: TrackingCategory } = i;

            i.Options = [
              ...Options.map(({ Name, TrackingOptionID }) => ({
                TrackingCategory,
                Name,
                TrackingOptionID,
              })),
            ];
          }
        }),
    }
  );
};
